"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.transactionTypeTransitions = exports["default"] = void 0;

var _TransactionState = _interopRequireDefault(require("../eth/TransactionState"));

var TransactionType = {
  oasis: 'oasis',
  transaction: 'transaction'
};
exports["default"] = TransactionType;
var transactionLifeCycle = {
  initialized: [_TransactionState["default"].pending, _TransactionState["default"].error],
  pending: [_TransactionState["default"].error, _TransactionState["default"].mined],
  mined: [_TransactionState["default"].finalized, _TransactionState["default"].error],
  finalized: [],
  error: []
};
var transactionTypeTransitions = {
  transaction: transactionLifeCycle
};
exports.transactionTypeTransitions = transactionTypeTransitions;